import React from 'react'
import { useTranslation } from 'react-i18next'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { useManagement, usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import Select, { CSSObjectWithLabel } from 'react-select'
import managementSelectors from 'client/store/management/managementSelectors'
interface LinkSourcePopupProps {
  popupid?: string
  update: (popupid: string) => void
}
type OptionType = {
  label: string
  value: string
}

const customStyles = {
  menu: (provided: CSSObjectWithLabel) => ({
    ...provided,
    padding: 0,
    borderRadius: '8px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    marginTop: '4px',
    border: '1px solid #E4E5E7',
  }),
  menuList: (provided: CSSObjectWithLabel) => ({
    ...provided,
    padding: 0,
    borderRadius: '8px',
  }),
  control: (provided: CSSObjectWithLabel) => ({
    ...provided,
    height: '40px',
    minHeight: '40px',
    border: '1px solid #E4E5E7',
    borderRadius: '8px',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#9ca3af',
    },
  }),
  option: (provided: CSSObjectWithLabel, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#f3f4f6' : 'white',
    color: '#111827',
    padding: '8px 12px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#f3f4f6',
    },
  }),
  valueContainer: (provided: CSSObjectWithLabel) => ({
    ...provided,
    height: '38px',
    padding: '0 12px',
  }),
  singleValue: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: '#111827',
    fontSize: '14px',
  }),
  input: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: '#111827',
    margin: 0,
    padding: 0,
  }),
  placeholder: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: '#9ca3af',
    fontSize: '14px',
  }),
  indicatorsContainer: (provided: CSSObjectWithLabel) => ({
    ...provided,
    paddingRight: '8px',
  }),
  dropdownIndicator: (provided: CSSObjectWithLabel) => ({
    ...provided,
    padding: '0',
    color: '#9ca3af',
    '&:hover': {
      color: '#6b7280',
    },
  }),
  clearIndicator: (provided: CSSObjectWithLabel) => ({
    ...provided,
    padding: '0',
    color: '#9ca3af',
    '&:hover': {
      color: '#6b7280',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
}
export const LinkSourcePopup = ({ popupid, update }: LinkSourcePopupProps) => {
  const { t } = useTranslation()
  const editingEntityId = useManagement(managementSelectors.getEditingId)
  const editingEntity = usePage(page =>
    pageSelectors.getEntityById(page, editingEntityId),
  )
  const popups = usePage(pageSelectors.getWebsiteGlobalOrPagePopupEntities)(
    editingEntity ?? undefined,
  )

  const options: OptionType[] = popups.map(popup => ({
    label:
      popup.type === EntityTypeEnum.Popup ? popup.title : popup.options.title,
    value: popup.id,
  }))

  const handlePopupChange = (selected: OptionType | null) => {
    update(selected?.value as string)
  }
  const selectedOption =
    options.find(option => option.value === popupid) ?? null
  return (
    <div className="flex justify-between items-center py-3 px-6">
      <label htmlFor="popup-input" className="block text-heading-5">
        {t('components.core.text_editor.link_toolbar.popup')}
      </label>
      <Select<OptionType>
        placeholder={t('entity_settings.button.blog_link.choose_blog_source')}
        styles={customStyles}
        options={options}
        onChange={handlePopupChange}
        value={selectedOption}
        isClearable
        className=" w-2/3 text-left"
      />
    </div>
  )
}
